import { useEffect, useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PartnerPicker } from "./PartnerPicker";

export function ParentsDialog({ open, onOpenChange, onChanged }) {
  const [d, setD] = useState(null);
  const load = () => api.get("/monitoring/parents").then((r) => setD(r.data.parents)).catch(() => setD([]));
  useEffect(() => { if (open) { setD(null); load(); } }, [open]);
  const save = async (id, partner_id) => {
    try {
      await api.put(`/monitoring/parents/${encodeURIComponent(id)}`, { partner_id });
      toast.success(partner_id ? "Account abbinato" : "Abbinamento rimosso");
      load(); onChanged();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] max-w-3xl overflow-y-auto border-neutral-800 bg-neutral-950 text-white" data-testid="parents-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="font-heading text-xl">Abbinamento account installatore FIER → Partner</DialogTitle></DialogHeader>
        <p className="text-xs text-neutral-400">Tutti gli impianti creati sotto un account installatore vengono assegnati al Partner scelto. Con «Divisione Torri» l'intero account diventa direzionale. Gli impianti sotto «torriadmin» si abbinano dalla scheda impianto o con la selezione multipla in lista.</p>
        {!d ? <Loader2 className="h-5 w-5 animate-spin" /> : (
          <div className="space-y-2" data-testid="parents-list">
            {d.filter((p) => !p.diretto_torri).map((p) => (
              <div key={p.id} className="flex flex-wrap items-center gap-3 rounded-xl border border-neutral-800 px-3 py-2" data-testid={`parent-row-${p.id}`}>
                <div className="min-w-0 flex-1">
                  <div className="truncate font-mono text-sm text-white">{p.id}</div>
                  <div className="text-[11px] text-neutral-500">{p.n_impianti} impianti</div>
                </div>
                {!p.partner_id && p.suggerito && (
                  <button type="button" onClick={() => save(p.id, p.suggerito.partner_id)} data-testid={`parent-suggest-${p.id}`}
                    className="inline-flex items-center gap-1 rounded-full border border-amber-500/40 px-3 py-1 text-xs text-amber-300 hover:bg-amber-500/10">
                    <Sparkles className="h-3.5 w-3.5" />{p.suggerito.partner_name}
                  </button>
                )}
                <PartnerPicker value={p.partner_id} label={p.partner_name} onPick={(pid) => save(p.id, pid)} testid={`parent-picker-${p.id}`} />
              </div>
            ))}
            {d.filter((p) => p.diretto_torri).map((p) => <p key={p.id} className="pt-2 text-xs text-neutral-500">«{p.id}»: {p.n_impianti} impianti creati direttamente da Torri, da abbinare singolarmente.</p>)}
            {!d.length && <p className="text-sm text-neutral-500">Nessun account installatore: attendi il completamento della sincronizzazione.</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
